let dropdownLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['trigger', 'backdrop']
  }

  connectedCallback () {
    if (!dropdownLoaded) {
      return this.render()
    }

    super.connectedCallback()

    this.setHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onBackdropClick = this.onBackdropClick.bind(this)
    this.onLinkClick = this.onLinkClick.bind(this)

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.onTriggerClick,
    )
    this.listeners.add(this, 'click', this.onLinkClick)
    this.listeners.add(
      this.externalEls.backdrop.element,
      'click',
      this.onBackdropClick,
    )
  }

  onTriggerClick () {
    this.isOpen = !this.isOpen
  }

  onBackdropClick (e) {
    this.isOpen = false
  }

  onLinkClick (e) {
    const item = e.target.closest(this.els.item.selector)
    if (!item) return

    const hasChild = item.querySelector(this.els.pane.selector) != null
    const isBack = item.hasAttribute('data-back')

    if (hasChild === false && isBack === false) return true

    e.preventDefault()

    if (isBack) {
      return this.handleBack(item)
    }

    const parentPane = item.closest(this.els.pane.selector)
    const childPane = item.querySelector(this.els.pane.selector)

    if (!childPane) return

    childPane.setAttribute('aria-current', 'true')
    parentPane.dataset.activeChild = 'true'
  }

  handleBack (item) {
    const parentPane = item.closest(this.els.pane.selector)
    parentPane.setAttribute('aria-current', 'false')

    const parentPanesParent = parentPane.parentNode.closest(
      this.els.pane.selector,
    )
    parentPanesParent.setAttribute('aria-current', 'true')
    parentPanesParent.dataset.activeChild = 'false'
  }

  render () {
    window.BAO.sectionRenderer
      .fetch('header', '/?view=mobile-menu')
      .then(res => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setHeight () {
    const panes = window.BAO.Utils.getElements(this.els.pane.selector, {
      context: this,
    })
    const tallestPane = panes.reduce((height, pane) => {
      if (pane.offsetHeight > height) {
        height = pane.offsetHeight
      }

      return height
    }, 0)

    this.style.height = `${tallestPane}px`
  }

  get isOpen () {
    return this.hasAttribute('open')
  }

  set isOpen (val) {
    val ? this.setAttribute('open', '') : this.removeAttribute('open')

    this.externalEls.trigger.element.setAttribute(
      'aria-current',
      val.toString(),
    )
    document.body.classList.toggle('util-MobileMenuOpen', val)
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
